import { Component, OnInit, inject } from '@angular/core';

import { FooterStore } from '../../../state/footer/footer.store';
import { SettingsStore } from '../../../state/settings/settings.store';
import { DswFooterComponent } from '@vi-succ/design-system-web';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'vp-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [DswFooterComponent, AsyncPipe, TranslatePipe]
})
export class FooterComponent implements OnInit {
    public footerStore = inject(FooterStore);
    public settingsStore = inject(SettingsStore);

    public readonly year = new Date().getFullYear();

    public ngOnInit(): void {
        this.footerStore.getApiInfo();
    }
}
